module.exports = __webpack_public_path__ + "media/3.52bdba92.mp3";